import { render } from "./subScription.vue?vue&type=template&id=5db74ba2&scoped=true"
import script from "./subScription.vue?vue&type=script&lang=js"
export * from "./subScription.vue?vue&type=script&lang=js"

import "./subScription.vue?vue&type=style&index=0&id=5db74ba2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db74ba2"]])

export default __exports__